module.exports = __webpack_public_path__ + "static/img/38809r.a1a0994.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/38809r.jpg
// module id = COHn
// module chunks = 1